import React, { use, useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import allTeams from '../../data/teams';
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré

interface ChartGameResumeProps {
  game: any; // Replace `any` with the actual type for `game`
  homeTeam: any; // Replace `any` with the actual type for `homeTeam`
  awayTeam: any; // Replace `any` with the actual type for `awayTeam`
}

interface Team {
  id: number,
  franchiseId: number,
  fullName: string,
  leagueId: number,
  rawTricode: string,
  triCode: string,
  colors : string[],
  conference: string,
  division: string,
}

interface HitEvent {
  eventId: number;
  periodDescriptor: {
    number: number;
    periodType: string;
    maxRegulationPeriods: number;
  };
  timeInPeriod: string;
  timeRemaining: string;
  situationCode: string;
  homeTeamDefendingSide: string;
  typeCode: number;
  typeDescKey: string;
  sortOrder: number;
  details: {
    xCoord: number;
    yCoord: number;
    zoneCode: string;
    eventOwnerTeamId: number;
    hittingPlayerId: number;
    hitteePlayerId: number;
  };
}

interface ShotEvent {
  eventId: number;
  periodDescriptor: {
    number: number;
    periodType: string;
    maxRegulationPeriods: number;
  };
  timeInPeriod: string;
  timeRemaining: string;
  situationCode: string;
  homeTeamDefendingSide: string;
  typeCode: number;
  typeDescKey: string;
  sortOrder: number;
  details: {
    xCoord: number;
    yCoord: number;
    zoneCode: string;
    shotType: string;
    shootingPlayerId: number;
    goalieInNetId: number;
    eventOwnerTeamId: number;
    awaySOG: number;
    homeSOG: number;
  };
}

interface GoalEvent {
  eventId: number;
  periodDescriptor: {
    number: number;
    periodType: string;
    maxRegulationPeriods: number;
  };
  timeInPeriod: string;
  timeRemaining: string;
  situationCode: string;
  homeTeamDefendingSide: string;
  typeCode: number;
  typeDescKey: string;
  sortOrder: number;
  details: {
    xCoord: number;
    yCoord: number;
    zoneCode: string;
    shotType: string;
    scoringPlayerId: number;
    scoringPlayerTotal: number;
    assist1PlayerId: number;
    assist1PlayerTotal: number;
    eventOwnerTeamId: number;
    goalieInNetId: number;
    awayScore: number;
    homeScore: number;
    highlightClipSharingUrl: string;
    highlightClip: number;
  };
  pptReplayUrl: string;
}


interface Play {

}


const ChartGameResume: React.FC<ChartGameResumeProps> = ({ game, homeTeam, awayTeam }) => {
    const [gamePlay, setGamePlay] = useState(game);
    const [homeshots, setHomeshots] = useState<string[]>([]);
    const [awayshots, setAwayshots] = useState<string[]>([]);
    const [homeShotsPerMinute, setHomeShotsPerMinute] = useState<string[]>([]);
    const [awayShotsPerMinute, setAwayShotsPerMinute] = useState<string[]>([]);
    const [homeTeamColor, setHomeTeamColor] = useState<string[]>([]);
    const [awayTeamColor, setAwayTeamColor] = useState<string[]>([]);
    const [graphlength, setGraphlength] = useState(60);
    
    const getTeamColor = (teamId: number, allTeams: Team[]) => {
      const team = allTeams.find((team) => team.id === teamId);
      return team ? team.colors : null; // Return the color if the team is found, otherwise return null
    };

    const processShotsByMinute = (shots: any[]) => {
      const shotsPerMinute = Array(60 + 5).fill(0); // Initialize an array for 60 minutes + 5 minutes of overtime
      shots.forEach((shot) => {
        let minute = Math.min(parseInt(shot.timeInPeriod.split(':')[0], 10), 59); // Extract the minute from timeInPeriod
        let periodOffset = 0;
    
        if (shot.periodDescriptor.number === 4) {
          // Overtime: Add 60 minutes (3 periods) + 0 additional minutes for overtime
          periodOffset = 60;
          setGraphlength(65);
        } else if (shot.periodDescriptor.number > 1) {
          // Regular periods: Add 20 minutes for each period beyond the first
          periodOffset = (shot.periodDescriptor.number - 1) * 20;
        }
    
        minute += periodOffset; // Add the offset to the minute
        if (minute < shotsPerMinute.length) {
          shotsPerMinute[minute]++;
        } else {
          console.warn(`Minute ${minute} exceeds the array bounds.`);
        }
      });
      for (let i = 1; i < shotsPerMinute.length; i++) {
        shotsPerMinute[i] += shotsPerMinute[i - 1];
      }
      return shotsPerMinute;
    };

    const getShotByTeam = (teamId: number, game: { plays: any[] }) => {
        const actions = game.plays;
        if (!Array.isArray(actions)) {
          console.warn("game.plays is not an array or is undefined:", actions);
          return []; // Retourne un tableau vide si `actions` est invalide
      }
        return actions.filter(play => {
          if(play.typeDescKey === "shot-on-goal" || play.typeDescKey === "goal")
          {
            return play.details.eventOwnerTeamId === teamId;
          }
      });
    }



    useEffect(() => { 
      const safeHomeTeamColor: string[] = getTeamColor(homeTeam.id, allTeams) || ["#FF0000"]; // Default to black
      setHomeTeamColor(safeHomeTeamColor);
      const safeAwayTeamColor: string[] = ["#ff0000"]; // Default to black
      setAwayTeamColor(safeAwayTeamColor);
  
    }, [homeTeam, awayTeam, game, allTeams]);

    useEffect(() => {
      const ShotByHomeTeam: string[] = getShotByTeam(homeTeam.id, game) || [];
      const ShotByAwayTeam: string[] = getShotByTeam(awayTeam.id, game) || [];
      setHomeshots(ShotByHomeTeam);      
      setAwayshots(ShotByAwayTeam);

      const ShotByHomeTeamPerMinute: string[] = processShotsByMinute(ShotByHomeTeam);
      const ShotByAwayTeamPerMinute: string[] = processShotsByMinute(ShotByAwayTeam);


      setHomeShotsPerMinute(ShotByHomeTeamPerMinute);
      setAwayShotsPerMinute(ShotByAwayTeamPerMinute);  

    }, [homeTeam, awayTeam, game, allTeams]);
//awayTeam.abbrev

    const ArbitraryLine = {
      id: 'ArbitraryLine',
      afterDatasetsDraw(chart: any, args: any, options: any) {
        const {ctx, chartArea: {top, bottom, left, right}, scales: {x, y}} = chart;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x.getPixelForValue(20), top); // Change 10 to the desired Y value
        ctx.lineTo(x.getPixelForValue(20), bottom); // Change 10 to the desired Y value
        ctx.moveTo(x.getPixelForValue(40), top); // Change 10 to the desired Y value
        ctx.lineTo(x.getPixelForValue(40), bottom); // Change 10 to the desired Y value
        ctx.moveTo(x.getPixelForValue(60), top); // Change 10 to the desired Y value
        ctx.lineTo(x.getPixelForValue(60), bottom); // Change 10 to the desired Y value
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'gray';
        ctx.stroke();
        ctx.restore();
      } 
    }

return (
    <div style={{ width: "100%", maxHeight: "500px" }} className="teamContent" >
        <div className="title">SHOTS ON GOAL</div>
        <Bar  className="gameChart"
        plugins={[ArbitraryLine]}
        data={{
          labels: Array.from({ length: graphlength }, (_, i) => i), // Minutes 1 to 60
          datasets: [
            {
              label: homeTeam?.commonName?.default+" (Home)",
              data: homeShotsPerMinute,
              backgroundColor: homeTeamColor["0"],
              borderColor: homeTeamColor["0"],
              barPercentage: 1,
            },
            {
              label: awayTeam?.commonName?.default+" (Away)",
              data: awayShotsPerMinute,
              backgroundColor: "#ffffff",
              borderColor: "#ffffff",
              barPercentage: 1,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Shots on Goal Per Minute",
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: "Minute",
              },
              type: "category",
              // ticks: {
              //   stepSize: 10, // Set the interval for the x-axis grid
              // },
              ticks: {
                autoSkip: false,
                callback: (value, index) => {
                  // Show only every 5th label
                  return index % 5 == 0 ? value : "";
                },
              },
              grid: {
                color: "rgba(0, 0, 0, 0.1)", // Only draw grid lines for y-axis
              },
//              beginAtZero: true,
            },
            y: {
              title: {
                display: true,
                text: "Number of Shots",
              },
              beginAtZero: true,
            },
          },
        }}
      />
      </div>      
  );
}

export default ChartGameResume;